import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PharmacyDetailsComponent} from './pharmacy-details.component';
import {ReactiveFormsModule} from '@angular/forms';
import {InputModule} from '../input/input.module';
import {DropdownModule} from '../dropdown/dropdown.module';
import {ButtonModule} from '../button/button.module';
import {DatepickerInputModule} from '../datepicker-input/datepicker-input.module';
import {NpiNumberComponent} from './npi-number/npi-number.component';
import {PharmacyFormComponent} from './pharmacy-form/pharmacy-form.component';
import {EditPharmacyDialogComponent} from './edit-pharmacy-dialog/edit-pharmacy-dialog.component';
import {DialogModule} from '../dialog/dialog.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { OptionsListModule } from '../options-list/options-list.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

@NgModule({
  declarations: [
    PharmacyDetailsComponent,
    NpiNumberComponent,
    PharmacyFormComponent,
    EditPharmacyDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    DropdownModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ButtonModule,
    DatepickerInputModule,
    DialogModule,
    CheckboxModule,
    OptionsListModule
  ],
  exports: [
    PharmacyDetailsComponent,
    NpiNumberComponent,
    PharmacyFormComponent,
    EditPharmacyDialogComponent,
  ],
})
export class PharmacyDetailsModule {
}
